module.exports={
  "not-sent" : "Not Sent",
  "sent" : "Sent",
  "paid" : "Paid",
  "part-paid" : "Part Paid",
  "cancelled" : "Cancelled"
}
